import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: SVGSVGElement
  Blocks: { default: [] }
}

const StarBob: TOC<Signature> = <template>
  <svg ...attributes class="animate-bob" viewBox="0 0 44 44" fill="none">
    <polygon
      points="22,3 26.9,15.2 40,15.2 29.5,23.6 33.5,36.5 22,28.6 10.5,36.5 14.5,23.6 4,15.2 17.1,15.2"
      fill="#FFD93D"
      stroke="#F4B400"
      stroke-width="1.2"
      stroke-linejoin="round"
    />
    <circle cx="18" cy="19" r="1.8" fill="#1a1a2e" />
    <circle cx="26" cy="19" r="1.8" fill="#1a1a2e" />
    <circle cx="18.5" cy="18.2" r=".65" fill="#fff" />
    <circle cx="26.5" cy="18.2" r=".65" fill="#fff" />
    <path d="M18,24 Q22,28 26,24" stroke="#1a1a2e" stroke-width="1.5" stroke-linecap="round" fill="none" />
    <ellipse cx="15" cy="22.5" rx="2.4" ry="1.8" fill="#FF9E9E" opacity=".55" />
    <ellipse cx="29" cy="22.5" rx="2.4" ry="1.8" fill="#FF9E9E" opacity=".55" />
    <circle cx="30" cy="10" r="2" fill="#FFE066" opacity=".8" />
    <circle cx="12" cy="12" r="1.4" fill="#FFE066" opacity=".6" />
    <circle cx="34" cy="18" r="1" fill="#FFE066" opacity=".6" />
  </svg>
</template>

export default StarBob
